import React from "react";

const Document = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1216_15535)">
      <path d="M16 0H0V16H16V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M13 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2Z"
        stroke="#333333"
        strokeWidth="1.12281"
        strokeLinejoin="round"
      />
      <path
        d="M11.3334 6.66699H4.66675"
        stroke="#333333"
        strokeWidth="1.12281"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66675 9H4.66675"
        stroke="#333333"
        strokeWidth="1.12281"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1216_15535">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default React.memo(Document);
